module.exports = __webpack_public_path__ + "static/media/penWhite.3960c282.svg";